export default "__VITE_ASSET__B5pLwhr9__"